<template>
	<div id="fontesPOL">
		<a-row type="flex" justify="space-between" align="bottom" :gutter="20">
			<a-col :span="22">
				<a-input-search					
					v-model="strSearch"
					:maxLength=100
					placeholder="Insira o texto a ser pesquisado"
					@search="onSearch"					
					:disabled="loading"
					:allowClear="strSearch!=''"
				>
					<a-button slot="enterButton" type="primary" :disabled="loading">Pesquisar</a-button>
				</a-input-search>
			</a-col>
			<a-col :span="2" style="margin-top: 20px; text-align: center;">
                <div>
                    <a-tooltip>
                        <template slot="title">Exportar Excel</template>
                        <a-button
                            type="primary"
                            shape="circle"
                            icon="file-excel"
                            size="default"
                            @click.stop.prevent="exportarExcel"
                            style="textAlign: center;"
                            :disabled="(data.length <= 0)"
                        />
                    </a-tooltip>
                </div>
            </a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idFontesPOL"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template slot="ativo" slot-scope="ativo, record">
					<a-icon type="check-circle" class="sucess" v-if="record.ativo"/>
					<a-icon type="close-circle" class="danger" v-else/>
				</template>
				<template slot="dataCadastro" slot-scope="dataCadastro, record">
					{{formatarDataLocal(record.dataCadastro, true, 'DD/MM/YYYY HH:mm:ss')}}
				</template>
				<template slot="complemento" slot-scope="complemento, record">
					<div>
						<a-popover title="Dados complementares" :overlayStyle="oStyle" placement="rightTop" id="teste">
							<template slot="content">
								<a-table
									id="tabelaCompl"
									:columns="columnsCompl"
									:rowKey="record => record.$id"
									:dataSource="[record]"                                    
									size="middle"
									:pagination="false"
								>
									<template slot="usaDuasAutenticacao" slot-scope="usaDuasAutenticacao, record">
										<a-icon type="check-circle" class="sucess" v-if="record.usaDuasAutenticacao"/>
										<a-icon type="close-circle" class="danger" v-else/>
									</template>
								</a-table>
							</template>
							<a-icon type="plus-circle" class="cursor" style="margin-left: 17px;"/>
						</a-popover>
					</div>
				</template>
				<template slot="editar" slot-scope="editar, record">
					<div>
						<a-tooltip>
							<template slot="title">Editar fonte POL</template>
							<a-icon 
								type="form" 
								class="cursor"
								@click="editarFontePOL(record)"/>
						</a-tooltip>
					</div>
				</template>
			</a-table>

			<modal-component
				class="modal-component"
				title="Editar Fonte POL"
				ref="modalFontesPOL"
				width="40%"
				:maskClosable="false"
			>
				<a-row>
					<span>Nome Extenso:</span>
					<a-input class="tr-input-modal" v-model="fontePOL.nome_extenso" :disabled="true" readOnly/>
				</a-row>
				<a-row :gutter="20">
					<a-col :span="10">
						<span>Nome:</span>
						<a-input class="tr-input-modal" v-model="fontePOL.nome" :disabled="true" readOnly/>
					</a-col>
					<a-col :span="4">
						<span>UF:</span>
						<a-input class="tr-input-modal" v-model="fontePOL.uf" :disabled="true" readOnly/>
					</a-col>
					<a-col :span="4">
						<span>Grau:</span>
						<a-input class="tr-input-modal" v-model="fontePOL.obs_grau" :disabled="true" readOnly/>
					</a-col>
					<a-col :span="6">
						<span>Justiça:</span>
						<a-input class="tr-input-modal" v-model="fontePOL.justica" :disabled="true" readOnly/>
					</a-col>
				</a-row>
				<a-row :gutter="20">
					<a-col :span="8">
						<span class="tr-label">Sistema:</span>
						<a-input class="tr-input-modal" v-model="fontePOL.sistema" :maxLength=20 @change="upperCase()"/>
					</a-col>
					<a-col :span="16">
						<span class="tr-label">Sigla Kurier:</span>
						<a-input class="tr-input-modal" v-model="fontePOL.siglaKurier" :maxLength=100 @change="upperCase()"/>
					</a-col>
				</a-row>
				<a-row :gutter="20">
					<a-col :span="18">
						<span class="tr-label">Nome Kurier:</span>
						<a-input class="tr-input-modal" v-model="fontePOL.nomenclaturaKurier" :maxLength=200 />
					</a-col>
					<a-col :span="6">				
						<span class="tr-label">Tipo Perfil Tribunal:</span>
						<a-select class="tr-ant-select" v-model="fontePOL.tipoPerfilTribunalSTR" @change="handlePerfilTribunalPerfil" style="width: 100%;">
							<a-select-option value="1">ADVOGADO</a-select-option>
							<a-select-option value="2">REPRESENTANTE</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row>
					<span>Link Tribunal:</span>
					<a-input class="tr-input-modal" v-model="fontePOL.tri_link"/>
				</a-row>
				<a-row>
					<span>Usa 2 Autenticações:</span>
					<a-switch style="margin-left: 15px;" v-model="fontePOL.usaDuasAutenticacao" @change="handlerSwitchDuasAutencacaoChange">
						<a-icon type="check" slot="checkedChildren"/>
						<a-icon type="close" slot="unCheckedChildren"/>
					</a-switch>
				</a-row>
				<a-row style="margin-top: 10px;">
					<a-checkbox @change="onChangeCheck">
						Desativar PERMANENTE ?
					</a-checkbox>
					<a-tooltip>
						<template slot="title">Ao desativar PERMANENTE a FontePOL, todos os contratos vinculadas a ele serão desativados consequentemente e a FontePOL NÃO poderá ser reativada.</template>
						<a-icon type="info-circle" style="color: #ff0130;"/>
					</a-tooltip>
				</a-row>
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">
							<a-switch style="margin-left: 15px;" v-model="fontePOL.ativo" @change="handlerSwitchChange" :disabled="desativarPermanente">
								<a-icon type="check" slot="checkedChildren"/>
								<a-icon type="close" slot="unCheckedChildren"/>
							</a-switch>
							<span style="margin-left: 10px;">Situação</span>
							<a-tooltip>
								<template slot="title">Ao desativar a FontePOL, todos os contratos vinculadas a ele serão desativados consequentemente.</template>
								<a-icon type="info-circle" style="margin-left: 10px; color: #ff0130;"/>
							</a-tooltip>
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="fontePOL-form-button" @click.prevent="handleCancel">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="fontePOL-form-button"
										type="primary"
										@click.prevent="handleOkEditFontePOL()"
										v-if="habilitarFuncionalidade('PermitirAlterar')"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</span>
			</modal-component>
		</a-row>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const columns = [
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),
		//width: "20%",
		scopedSlots: { customRender: "nome" }
	},
	{
		title: "UF",
		dataIndex: "uf",
		sorter: (a, b) => a.uf.localeCompare(b.uf),
		width: "4%",
		scopedSlots: { customRender: "uf" }
	},
	{
		title: "Grau",
		dataIndex: "obs_grau",
		width: "5%",
        sorter: (a, b) => a.obs_grau.localeCompare(b.obs_grau),
		scopedSlots: { customRender: "obs_grau" }
	},
	{
		title: "Situação",
		dataIndex: "ativo",
		sorter: (a, b) => a.ativo - b.ativo,
		width: "6%",
		scopedSlots: { customRender: "ativo" }
	},
	{
		title: "Justiça",
		dataIndex: "justica",
		sorter: (a, b) => a.justica.localeCompare(b.justica),
		width: "7%",
		scopedSlots: { customRender: "justica" }
	},
    {
		title: "Sistema",
		dataIndex: "sistema",
		sorter: (a, b) => a.sistema.localeCompare(b.sistema),
		width: "9%",
		scopedSlots: { customRender: "sistema" }
	},
    {
		title: "Sigla Kurier",
		dataIndex: "siglaKurier",
		sorter: (a, b) => a.siglaKurier.localeCompare(b.siglaKurier),
		width: "17%",
		scopedSlots: { customRender: "siglaKurier" }
	},
    {
		title: "Tipo Perfil Tribunal",
		dataIndex: "tipoPerfilTribunalNome",
		sorter: (a, b) => a.tipoPerfilTribunalNome.localeCompare(b.tipoPerfilTribunalNome),
		width: "10%",
		scopedSlots: { customRender: "tipoPerfilTribunalNome" }
	},
    {
		title: "Data Cadastro",
		dataIndex: "dataCadastro",
        align: "center",
		width: "11%",
        scopedSlots: { customRender: "dataCadastro" },
		sorter: (a, b) => moment(a.dataCadastro) - moment(b.dataCadastro)
	},	
	{
		title: "Complemento",
		width: "9%",
		align: "center",
		scopedSlots: { customRender: "complemento" }
	},
	{
		key: "idFontesPOL",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "5%",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsCompl = [
	{
		title: "Duas Autenticação",
		dataIndex: "usaDuasAutenticacao",
		sorter: (a, b) => a.usaDuasAutenticacao - b.usaDuasAutenticacao,
		width: 160,
		align: 'center',
		scopedSlots: { customRender: "usaDuasAutenticacao" }
	},
  {
		title: "Link Tribunal",
		dataIndex: "tri_link",
		sorter: (a, b) => a.tri_link.localeCompare(b.tri_link),		
		scopedSlots: { customRender: "tri_link" }
	},
];

export default {	
	name: "FontesPol",
	data() {
		return {
			idTela: 9,
			data: [],
			strSearch: null,
			//searchText: "",
			pagination: {},
			loading: false,
			columns,
			columnsCompl,
			oStyle: {
				width: "30%"
			},
			fontePOL: {
				idFontesPOL: 0,
				nome: '',
				nome_extenso: '',
				uf: '',
				obs_grau: '',
				tipo_justica: '',
				justica: '',
				sistema: '',
				nomenclaturaKurier: '',
				siglaKurier: '',
				tipoPerfilTribunal: 0,
				tipoPerfilTribunalSTR: '0',
				ativo: false,
				obsKurier: '',
				tri_link: '',
				usaDuasAutenticacao: false
			},
			oldAtivoStatus: true,
			desativarPermanente: false
		};
	},
	mounted() {
		this.fetch({ search: true });
	},
	methods: {
		upperCase() {
            this.fontePOL.sistema = this.fontePOL.sistema.toUpperCase();
			this.fontePOL.siglaKurier = this.fontePOL.siglaKurier.toUpperCase();
        },
		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},
		fetch(params = {}) {
			this.loading = true;
			if (params.search) {
				IntimacaoWebApi.listarFontesPOL(params).then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Manutenção Fontes POL", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Manutenção Fontes POL", res.data.result);
					} else {
						let lstFontesPol = res.data.result.map(h => {
							return { 
								...h,
								justica: (h.tipo_justica == null || h.tipo_justica == '') ? '' : h.tipo_justica == 'F' ? 'FEDERAL' : 'ESTADUAL',
								tipoPerfilTribunalNome: h.tipoPerfilTribunal == null ? '' : h.tipoPerfilTribunal == 1 ? 'ADVOGADO' : 'REPRESENTANTE'
							}
						})
						this.data = lstFontesPol;						
						this.pagination = { current: 1 };
					}
				});
			} else {
				this.loading = false;
			}
		},
		onSearch(text) {
			this.fetch({ search: true, Text: text });
		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
		handlePerfilTribunalPerfil(value) {
			this.fontePOL.tipoPerfilTribunal = parseInt(value);
		},
		validarCampos(fontePOL){
			let camposValidos = true;			
			
			if (fontePOL.sistema.trim() == ""){
				showNotificationError(this, "Manutenção Fontes POL", "Sistema é um campo obrigatório!");
				camposValidos = false;
			}else if (fontePOL.siglaKurier.trim() == ""){
				showNotificationError(this, "Manutenção Fontes POL", "Sigla Kurier é um campo obrigatório!");
				camposValidos = false;	
			}else if (fontePOL.nomenclaturaKurier.trim() == ""){
				showNotificationError(this, "Manutenção Fontes POL", "Nome Kurier é um campo obrigatório!");
				camposValidos = false;
			}else if (fontePOL.tipoPerfilTribunal != 1 && fontePOL.tipoPerfilTribunal != 2){
				showNotificationError(this, "Manutenção Fontes POL", "Tipo Perfil Tribunal é um campo obrigatório!");
				camposValidos = false;
			}

			return camposValidos;
		},
		editarFontePOL(fontePOL) {
			this.fontePOL.idFontesPOL = fontePOL.idFontesPOL;
			this.fontePOL.nome = fontePOL.nome;
			this.fontePOL.nome_extenso = fontePOL.nome_extenso;
			this.fontePOL.uf = fontePOL.uf;
			this.fontePOL.obs_grau = fontePOL.obs_grau;
			this.fontePOL.tipo_justica = fontePOL.tipo_justica;
			this.fontePOL.justica = fontePOL.justica;
			this.fontePOL.sistema = fontePOL.sistema;
			this.fontePOL.nomenclaturaKurier = fontePOL.nomenclaturaKurier;
			this.fontePOL.siglaKurier = fontePOL.siglaKurier;
			this.fontePOL.tipoPerfilTribunal = fontePOL.tipoPerfilTribunal;
			this.fontePOL.tipoPerfilTribunalSTR = fontePOL.tipoPerfilTribunal != null ? fontePOL.tipoPerfilTribunal.toString() : '';
			this.fontePOL.ativo = fontePOL.ativo;
			this.oldAtivoStatus = fontePOL.ativo;
			this.fontePOL.obsKurier = fontePOL.obsKurier;
			this.desativarPermanente = false;
			this.fontePOL.tri_link = fontePOL.tri_link;
			this.fontePOL.usaDuasAutenticacao = fontePOL.usaDuasAutenticacao;
			this.$refs.modalFontesPOL.showModal();
		},
		handleOkEditFontePOL(e) {
			if(!this.validarCampos(this.fontePOL)){
				return;
			};

			if ((this.oldAtivoStatus == true) && (this.fontePOL.ativo == false)) {
				const _this = this;
				const x = _this.$createElement;				
				this.$confirm({				
					title: x('div', {}, [
							x('p', "Ao desativar a Fonte POL, todos os contratos vinculados a ele serão desativados consequentemente."),
						]),					
					content: h => <div style="font-size: 16px; color: #000000d9;">Deseja continuar?</div>,
					okText: 'Sim',        			
        			cancelText: 'Não',
					width: '25%',
					onOk() {
						_this.chamarAPIEditarFOntePOL();
					},
					onCancel() {},
				});
			} else {
				this.chamarAPIEditarFOntePOL();
			}			
		},
		chamarAPIEditarFOntePOL() {
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.atualizarFontesPOL(this.fontePOL, this.$store.state.auth.idUser)
				.then(res => {
					this.$refs.modalFontesPOL.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Manutenção Fontes POL", res.data.result);
						this.fetch({ search: true });
					} else
						showNotificationError(this, "Manutenção Fontes POL", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Manutenção Fontes POL", "Erro ao tentar editar Fonte POL.");
				});
		},
		handleCancel() {
			this.$refs.modalFontesPOL.handleCancel();
			this.fontePOL.idFontesPOL = 0;
			this.fontePOL.nome = '';
			this.fontePOL.nome_extenso = '';
			this.fontePOL.uf = '';
			this.fontePOL.obs_grau = '';
			this.fontePOL.tipo_justica = '';
			this.fontePOL.justica = '';
			this.fontePOL.sistema = '';
			this.fontePOL.nomenclaturaKurier = '';
			this.fontePOL.siglaKurier = '';
			this.fontePOL.tipoPerfilTribunal = 0;
			this.fontePOL.tipoPerfilTribunalSTR = '0';
			this.fontePOL.ativo = false;
			this.fontePOL.obsKurier = '';
			this.desativarPermanente = false;
			this.fontePOL.tri_link = '';
			this.fontePOL.usaDuasAutenticacao = false;
		},
		handlerSwitchChange(value) {
			this.fontePOL.ativo = value;
		},
		handlerSwitchDuasAutencacaoChange(value) {
			this.fontePOL.usaDuasAutenticacao = value;
		},
		onChangeCheck(e) {			
			this.desativarPermanente = e.target.checked;
			if (e.target.checked)
			{				
				this.handlerSwitchChange(false);
				this.fontePOL.obsKurier = 'NÃO ATIVAR !!!!' + '\r\n' + 'Desativado PERMANENTE pelo IdUsuário: ' + this.$store.state.auth.idUser;
			}
			else
			{
				this.fontePOL.obsKurier = '';				
			}
		},
		exportarExcel() {
			this.loading = true;
			IntimacaoWebApi.exportarFontesPOL()
				.then(res => {
					this.loading = false;
					let data = res.data;
					if (data !== null && typeof data !== "undefined") {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "Relatório FontesPOL.xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Manutenção Fontes POL", "Erro ao tentar gerar arquivo.");
				});
		},
	},
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

.ant-select {
	margin: 0px 0px 10px 0px;
}

.ant-switch {
	margin: 10px 0px 10px 0px;
}

.ant-input-affix-wrapper {
	margin: 0px 0px 10px 0px;
} 

.tr-input-modal {
	margin: 0px 0px 10px 0px;
}

.tr-ant-select {
	margin: 0px 0px 10px 0px;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.default {
	color: black;
}

.custom-filter-dropdown {
	padding: 8px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
	background-color: rgb(255, 192, 105);
	padding: 0px;
}

.cursor {
	cursor: pointer;
}

.cursor:hover {
  color: blue;
}
</style>

<style>
.fontePOL-form-button {
	width: 100px;
}
</style>